const OA_MENU_LABEL = 'OA审批'
const OA_PAGE_LABELS = new Set(['审批中心', '审批台账', '台账', '工资条管理'])

function collectIds(nodes, ids) {
  const items = nodes || []
  items.forEach(node => {
    ids.push(node.id)
    collectIds(node.children, ids)
  })
}

// The role tree should describe the pages users can actually enter. OA action
// permissions and legacy deep links remain assigned in the background, but do
// not appear as extra pages. Payroll is a separate, explicitly grantable page.
export function normalizeRoleMenuTree(nodes) {
  const hiddenIds = []
  const publicIds = []
  function normalize(nodesToNormalize) {
    return (nodesToNormalize || []).map(node => {
      if (node.label !== OA_MENU_LABEL) {
        return {
          ...node,
          ...(node.children ? { children: normalize(node.children) } : {})
        }
      }

      const children = []
      const sourceChildren = node.children || []
      sourceChildren.forEach(child => {
        if (!OA_PAGE_LABELS.has(child.label)) {
          collectIds([child], hiddenIds)
          return
        }
        collectIds(child.children, hiddenIds)
        const page = { ...child }
        delete page.children
        if (child.label === '审批中心') {
          page.disabled = true
          page.publicAccess = true
          publicIds.push(child.id)
        }
        children.push(page)
      })
      return { ...node, children }
    })
  }
  const options = normalize(nodes)
  return { options, hiddenIds, publicIds }
}

export function mergePreservedMenuIds(visibleIds, preservedIds) {
  return Array.from(new Set([...(visibleIds || []), ...(preservedIds || [])]))
}
